import type { SVGProps } from 'react';

const SvgPickMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.5088 3.08008C11.7165 2.64051 12.2835 2.64051 12.4912 3.08008L14.7998 7.96484C14.9491 8.28049 15.2464 8.51536 15.6084 8.57031L20.7695 9.35352C21.1903 9.41745 21.4459 10.0259 21.0693 10.4092L17.335 14.2119C17.0872 14.4642 16.9814 14.8177 17.0371 15.1572L17.9189 20.5264C17.9629 20.7944 17.8528 21.0135 17.6865 21.1396C17.5232 21.2635 17.3224 21.2894 17.1279 21.1826L12.5117 18.6484L12.3887 18.5908C12.1388 18.4924 11.8612 18.4924 11.6113 18.5908L11.4883 18.6484L6.87207 21.1826C6.6776 21.2894 6.47681 21.2635 6.31348 21.1396C6.14718 21.0135 6.0371 20.7944 6.08105 20.5264L6.96289 15.1572C7.01861 14.8177 6.91276 14.4642 6.66504 14.2119L2.93066 10.4092C2.55414 10.0258 2.80969 9.41746 3.23047 9.35352L8.3916 8.57031C8.75364 8.51537 9.05087 8.28046 9.2002 7.96484L11.5088 3.08008Z'
      stroke='currentColor'
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgPickMd;
